import React, { useEffect, useState } from "react";
import { fetchFeedDataForReels } from "../Utils/ReelsFetchFeeddata";
import "../Styles/ReelsgridBottomLayout.css";
// import "../../../Styles/ua-common-styles.css";
// import "../../../../Styles/common-styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faMapMarkerAlt, faCalendar } from "@fortawesome/free-solid-svg-icons";
import "../Styles/reels-common-settings.css"

const ReelsGridBottomLayout = ({ selectedReels = [], onReelSelect }) => {
  const [reels, setReels] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    async function loadReels() {
      const data = await fetchFeedDataForReels();
      setReels(data.reellist || []);
    }
    loadReels();
  }, []);

  const selectedReel = selectedIndex !== null ? reels[selectedIndex] : null;

  const goNext = (e) => {
    e.stopPropagation();
    setSelectedIndex((prev) => (prev < reels.length - 1 ? prev + 1 : prev));
  };

  const goPrev = (e) => {
    e.stopPropagation();
    setSelectedIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const closeModal = () => {
    setSelectedIndex(null);
  };

  // ⭐ Handle checkbox toggle
  const handleCheckboxChange = (reelId, e) => {
    e.stopPropagation(); // Prevent opening modal when clicking checkbox
    const isSelected = selectedReels.includes(reelId);

    if (isSelected) {
      onReelSelect(selectedReels.filter((id) => id !== reelId));
    } else {
      onReelSelect([...selectedReels, reelId]);
    }
  };

  // ⭐ Check if reel is selected
  const isReelSelected = (reelId) => {
    return selectedReels.includes(reelId);
  };

  // ⭐ Format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // ⭐ Format impressions count
  const formatImpressions = (count) => {
    if (count >= 1000000) {
      return `${(count / 1000000).toFixed(1)}M`;
    } else if (count >= 1000) {
      return `${(count / 1000).toFixed(1)}K`;
    }
    return count.toString();
  };

  return (
    <div className="ua-central-container" style={{ gap: 0, padding: "0 20px" }}>
      {reels.length === 0 ? (
        <p className="text-label">No reels found</p>
      ) : (
        reels.map((reel, index) => (
          <div
            key={reel.reelid}
            className="ua-profile-card"
            onClick={() => setSelectedIndex(index)}
            style={{
              position: "relative",
              cursor: "pointer",
              border: isReelSelected(reel.reelid)
                ? "2px solid #667eea"
                : "1px solid rgba(255,255,255,0.2)",
              transition: "all 0.3s ease",
              borderRadius: 12,
              overflow: "hidden",
              background: "rgba(0, 0, 0, 0.3)",
            }}
          >
            {/* ⭐ Checkbox in top right corner */}
            <div
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                zIndex: 10,
              }}
            >
              <input
                type="checkbox"
                checked={isReelSelected(reel.reelid)}
                onChange={(e) => handleCheckboxChange(reel.reelid, e)}
                onClick={(e) => e.stopPropagation()}
                style={{
                  width: 20,
                  height: 20,
                  cursor: "pointer",
                  accentColor: "#667eea",
                }}
                aria-label={`Select reel ${reel.reelid}`}
              />
            </div>

            {/* Thumbnail */}
            <img
              src={reel.thumbnail}
              alt="Reel Thumbnail"
              style={{
                width: "100%",
                height: 200,
                objectFit: "cover",
              }}
            />

            {/* Reel Information */}
            <div style={{ padding: "12px 15px" }}>
              {/* User ID */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginBottom: 8,
                }}
              >
                <img
                  src={reel.userProfileImage || "/default-avatar.png"}
                  alt="User"
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                    border: "2px solid #667eea",
                  }}
                />
                <p
                  className="text-header"
                  style={{
                    margin: 0,
                    fontWeight: "bold",
                    fontSize: 14,
                    color: "white",
                  }}
                >
                  {reel.userId}
                </p>
              </div>

              {/* Description */}
              <p
                className="text-label"
                style={{
                  margin: "8px 0",
                  fontSize: 13,
                  color: "rgba(255, 255, 255, 0.8)",
                  lineHeight: 1.4,
                }}
              >
                {reel.description || "No Description"}
              </p>

              {/* Metadata Row 1: Location & Date */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: 10,
                  fontSize: 12,
                  color: "rgba(255, 255, 255, 0.6)",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                  <FontAwesomeIcon icon={faMapMarkerAlt} style={{ fontSize: 12 }} />
                  <span>{reel.location || "Unknown"}</span>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                  <FontAwesomeIcon icon={faCalendar} style={{ fontSize: 12 }} />
                  <span>{formatDate(reel.date)}</span>
                </div>
              </div>

              {/* Metadata Row 2: Impressions */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 5,
                  marginTop: 8,
                  fontSize: 12,
                  color: "rgba(255, 255, 255, 0.6)",
                }}
              >
                <FontAwesomeIcon icon={faEye} style={{ fontSize: 12 }} />
                <span>{formatImpressions(reel.impressions)} views</span>
              </div>
            </div>
          </div>
        ))
      )}

      {/* Modal for Selected Reel */}
      {selectedReel && (
        <div
          onClick={closeModal}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.9)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              maxWidth: "90vw",
              maxHeight: "90vh",
            }}
          >
            {/* Video */}
            <video
              src={selectedReel.videoUrl}
              style={{
                width: "auto",
                maxWidth: 800,
                height: "auto",
                maxHeight: 600,
                borderRadius: 10,
              }}
              autoPlay
              controls
            />

            {/* Reel Info in Modal */}
            <div
              style={{
                background: "rgba(0, 0, 0, 0.8)",
                padding: "15px 20px",
                borderRadius: 10,
                marginTop: 15,
                maxWidth: 800,
                width: "100%",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                <img
                  src={selectedReel.userProfileImage || "/default-avatar.png"}
                  alt="User"
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    border: "2px solid #667eea",
                  }}
                />
                <div>
                  <p style={{ margin: 0, color: "white", fontWeight: "bold", fontSize: 16 }}>
                    {selectedReel.userId}
                  </p>
                  <p style={{ margin: 0, color: "rgba(255,255,255,0.6)", fontSize: 12 }}>
                    {selectedReel.location} • {formatDate(selectedReel.date)}
                  </p>
                </div>
              </div>

              <p style={{ color: "white", margin: "10px 0", fontSize: 14 }}>
                {selectedReel.description}
              </p>

              <div style={{ display: "flex", gap: 20, fontSize: 13, color: "rgba(255,255,255,0.7)" }}>
                <span>👁️ {formatImpressions(selectedReel.impressions)} views</span>
                <span>❤️ {selectedReel.likesCount} likes</span>
                <span>💬 {selectedReel.commentsCount} comments</span>
              </div>
            </div>

            {/* Navigation Buttons */}
            <div style={{ marginTop: 20, display: "flex", gap: 20 }}>
              <button
                onClick={goPrev}
                disabled={selectedIndex === 0}
                style={{
                  padding: "12px 24px",
                  background: selectedIndex === 0 ? "#555" : "#667eea",
                  color: "white",
                  borderRadius: 8,
                  border: "none",
                  cursor: selectedIndex === 0 ? "not-allowed" : "pointer",
                  fontWeight: 600,
                  fontSize: 14,
                  transition: "all 0.3s ease",
                }}
              >
                ← Previous
              </button>

              <button
                onClick={goNext}
                disabled={selectedIndex === reels.length - 1}
                style={{
                  padding: "12px 24px",
                  background: selectedIndex === reels.length - 1 ? "#555" : "#667eea",
                  color: "white",
                  borderRadius: 8,
                  border: "none",
                  cursor: selectedIndex === reels.length - 1 ? "not-allowed" : "pointer",
                  fontWeight: 600,
                  fontSize: 14,
                  transition: "all 0.3s ease",
                }}
              >
                Next →
              </button>
            </div>

            {/* Close Button */}
            <button
              onClick={closeModal}
              style={{
                position: "absolute",
                top: -10,
                right: -10,
                background: "#ff4444",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: 40,
                height: 40,
                fontSize: 20,
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReelsGridBottomLayout;